// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2HQNU","column":"style_column__3h_lZ"};